// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file rubykaigi/sponsor_app/asset_file_upload.proto (package rubykaigi.sponsor_app, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file rubykaigi/sponsor_app/asset_file_upload.proto.
 */
export const file_rubykaigi_sponsor_app_asset_file_upload: GenFile = /*@__PURE__*/
  fileDesc("Ci1ydWJ5a2FpZ2kvc3BvbnNvcl9hcHAvYXNzZXRfZmlsZV91cGxvYWQucHJvdG8SFXJ1YnlrYWlnaS5zcG9uc29yX2FwcCLbAQoPQXNzZXRGaWxlVXBsb2FkEhMKB2ZpbGVfaWQYASABKANCAjABEgsKA3VybBgCIAEoCRJCCgZmaWVsZHMYAyADKAsyMi5ydWJ5a2FpZ2kuc3BvbnNvcl9hcHAuQXNzZXRGaWxlVXBsb2FkLkZpZWxkc0VudHJ5EhAKCG1heF9zaXplGAQgASgDEhEKCXJlcG9ydF90bxgFIAEoCRIOCgJpZBgGIAEoCUICGAEaLQoLRmllbGRzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUIR6gIOUms6OlNwb25zb3JBcHBiBnByb3RvMw");

/**
 * An upload of an asset file in progress, such as a sponsor logo, an event image or an expense
 * receipt: a presigned POST to the storage, valid for 15 minutes.
 *
 * POST a multipart form to `url` holding every entry of `fields`, then `x-amz-checksum-algorithm`
 * set to "SHA256" and `x-amz-checksum-sha256` to the base64 SHA-256 digest of the file, then
 * `Content-Type` unless `fields` holds it, then the file itself as `file`. The storage refuses a
 * file larger than `max_size`. Report the upload to `report_to` afterwards.
 *
 * @generated from message rubykaigi.sponsor_app.AssetFileUpload
 */
export type AssetFileUpload = Message<"rubykaigi.sponsor_app.AssetFileUpload"> & {
  /**
   * ID of the asset file being uploaded.
   *
   * @generated from field: int64 file_id = 1 [jstype = JS_STRING];
   */
  fileId: string;

  /**
   * Where to POST the form.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * Form fields to send ahead of the file, as given.
   *
   * @generated from field: map<string, string> fields = 3;
   */
  fields: { [key: string]: string };

  /**
   * Largest file the storage accepts, in bytes.
   *
   * @generated from field: int64 max_size = 4;
   */
  maxSize: bigint;

  /**
   * Where to PUT the file's extension and the storage's version ID once the upload succeeds, which
   * marks the file uploaded.
   *
   * @generated from field: string report_to = 5;
   */
  reportTo: string;

  /**
   * file_id as a decimal string, for pages still running a script that reads `id`.
   *
   * @generated from field: string id = 6 [deprecated = true];
   * @deprecated
   */
  id: string;
};

/**
 * Describes the message rubykaigi.sponsor_app.AssetFileUpload.
 * Use `create(AssetFileUploadSchema)` to create a new message.
 */
export const AssetFileUploadSchema: GenMessage<AssetFileUpload> = /*@__PURE__*/
  messageDesc(file_rubykaigi_sponsor_app_asset_file_upload, 0);

